/**
 * Component: Article Share
 * -----------------------------------------------------------------------------
 * Logic related to Article Share.
 * @namespace ArticleShare
 */

import { on } from '~/helpers/utils'

/**
 * DOM selectors.
 */
const selectors = {
  link: '[js-article-share="link"]',
}

/**
 * Create a new Article Share object.
 */
export default () => {

  /**
   * Node Elements.
   */
  const nodes = {
    link: document.querySelectorAll(selectors.link),
  }

  /**
   * Initialize component.
   */
  function init() {
    setEventListeners()
  }

  /**
   * Set Event Listeners.
   */
  function setEventListeners() {
    nodes.link.forEach((link) => {
      on('click', link, handleLinkClick)
    })
  }

  /**
   * Handle UI After clicking link.
   * @param {Event} event
   */
  function handleLinkClick(event) {
    copyUrl().then(() => {
      const el = document.createElement('span')
      const content = document.createTextNode(event.target.dataset.tooltip)

      el.appendChild(content)

      event.target.append(el)

      setTimeout(() => {
        el.remove()
      }, 3000)
    })
  }

  /**
   * Copy text to clipboard
   * @returns {Promise}
   */
  function copyUrl() {
    try {
      return navigator.clipboard.writeText(window.location.href)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
